export function encodeURL(url) {
  return url.replace(/</g, '&lt;').replace(/"/g, '&quot;');
}
